

export const getErrorMessage = (error: any) => {
    if (typeof error === "string") { return error; }

    if (error.message) { return error.message; }

    if (error.type === "minLength") {
        return "Value too short.";
    } else if (error.type === "required") {
        return "Value is required";
    }
    return "Invalid value";
};
